const MOBILE_MAX_WIDTH = 767;

function isMobileWidth(width) {
  return width <= MOBILE_MAX_WIDTH;
}

function isPhoneCalendarLayout(width) {
  return isMobileWidth(width);
}

function defaultCalendarViewMode(width) {
  return isPhoneCalendarLayout(width) ? "day" : "week";
}

function weekLayoutOrientation(width) {
  return isPhoneCalendarLayout(width) ? "vertical" : "horizontal";
}

function subscribeMobileViewport(listener) {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return () => {};
  }

  const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
  const notify = () => listener(mediaQuery.matches);

  notify();
  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", notify);
    return () => mediaQuery.removeEventListener("change", notify);
  }

  mediaQuery.addListener(notify);
  return () => mediaQuery.removeListener(notify);
}

module.exports = {
  MOBILE_MAX_WIDTH,
  isMobileWidth,
  isPhoneCalendarLayout,
  defaultCalendarViewMode,
  weekLayoutOrientation,
  subscribeMobileViewport,
};
